module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "epi2"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("That I may reduce the monster to")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("Myself, and then may be myself")]), _vm._v(" "), _c('p', {
    staticClass: "epi1"
  }, [_vm._v("In face of the monster, be more than part")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("Of it, more than the monstrous player of")]), _vm._v(" "), _c('p', {
    staticClass: "epi1"
  }, [_vm._v("One of its monstrous lutes, not be")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("Alone, but reduce the monster and be,")]), _vm._v(" "), _c('p', {
    staticClass: "epi1"
  }, [_vm._v("Two things, the two together as one.…")]), _vm._v(" "), _c('p', {
    staticClass: "epir1"
  }, [_vm._v("—Wallace Stevens, from")]), _vm._v(" "), _c('p', {
    staticClass: "epir"
  }, [_vm._v("“The Man with the Blue Guitar")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-177ada57","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/xhtml/03_Epigraph.vue
// module id = 81
// module chunks = 0